const PageTransition = ({ children, className = '' }) => (
  <div className={`page-transition ${className}`}>
    {children}
  </div>
);

export default PageTransition;
